<app-header></app-header>

<div class="rts-course-default-area rts-section-gap">
  <div class="container">
    <div class="row g-5">
      <div class="col-lg-3">
        <div class="rts-course-filter-area">
          <div class="single-filter-left-wrapper">
            <h6 class="title">Pesquisar</h6>
            <div class="search-filter filter-body">
              <div class="input-wrapper">
                <input
                  type="text"
                  placeholder="Pesquisar Curso..."
                  [(ngModel)]="termoBusca"
                  (input)="filtrarCursos()"
                />
                <i class="fa-solid fa-search"></i>
              </div>
            </div>
          </div>

          <div class="single-filter-left-wrapper">
            <h6 class="title">Grau Acadêmico</h6>
            <div class="checkbox-filter filter-body">
              <div class="checkbox-wrapper">
                <div class="single-checkbox-filter">
                  <div class="check-box">
                    <input
                      type="checkbox"
                      id="type-1"
                      [checked]="grausSelecionados.includes('Bacharelado')"
                      (change)="alternarGrau('Bacharelado')"
                    />
                    <label for="type-1">Bacharelado</label>
                  </div>
                  <span class="number"
                    >({{ getTotalPorTag("Bacharelado") }})</span
                  >
                </div>

                <div class="single-checkbox-filter">
                  <div class="check-box">
                    <input
                      type="checkbox"
                      id="type-2"
                      [checked]="grausSelecionados.includes('Licenciatura')"
                      (change)="alternarGrau('Licenciatura')"
                    />
                    <label for="type-2">Licenciatura</label>
                  </div>
                  <span class="number"
                    >({{ getTotalPorTag("Licenciatura") }})</span
                  >
                </div>

                <div class="single-checkbox-filter">
                  <div class="check-box">
                    <input
                      type="checkbox"
                      id="type-3"
                      [checked]="grausSelecionados.includes('Tecnólogo')"
                      (change)="alternarGrau('Tecnólogo')"
                    />
                    <label for="type-3">Tecnólogo</label>
                  </div>
                  <span class="number"
                    >({{ getTotalPorTag("Tecnólogo") }})</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="single-filter-left-wrapper">
            <h6 class="title">Modalidade</h6>
            <div class="checkbox-filter filter-body">
              <div class="checkbox-wrapper">
                <div class="single-checkbox-filter">
                  <div class="check-box">
                    <input
                      type="checkbox"
                      id="modalidade-presencial"
                      [checked]="modalidadesSelecionadas.includes('Presencial')"
                      (change)="alternarModalidade('Presencial')"
                    />
                    <label for="modalidade-presencial">Presencial</label>
                  </div>
                  <span class="number">{{
                    getTotalPorModalidade("Presencial")
                  }}</span>
                </div>

                <div class="single-checkbox-filter">
                  <div class="check-box">
                    <input
                      type="checkbox"
                      id="modalidade-ead"
                      [checked]="modalidadesSelecionadas.includes('EAD')"
                      (change)="alternarModalidade('EAD')"
                    />
                    <label for="modalidade-ead">EAD</label>
                  </div>
                  <span class="number">{{ getTotalPorModalidade("EAD") }}</span>
                </div>
              </div>
            </div>
          </div>

          <a (click)="limparFiltros()" class="rts-btn btn-border">
            <i class="fa-regular fa-x"></i> Limpar Filtros
          </a>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="filter-small-top-full">
          <div class="left-filter"></div>
          <div class="right-filter">
            <span>
              Mostrando {{ cursosPaginados.length }} de
              {{ cursosFiltrados.length }} resultados
            </span>
          </div>
        </div>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div class="row g-5 mt--30">
              <div
                class="col-lg-4 col-md-6 col-sm-12 col-12"
                *ngFor="let curso of cursosPaginados"
              >
                <div class="rts-single-course">
                  <a [href]="curso.link" class="thumbnail">
                    <img [src]="curso.imagem" alt="course" />
                  </a>
                  <div class="tags-area-wrapper">
                    <div class="single-tag" *ngFor="let tag of curso.tags">
                      <span>{{ tag }}</span>
                    </div>
                  </div>
                  <div class="lesson-studente"></div>
                  <a>
                    <h5 class="title limit-lines">
                      {{ curso.nome }}
                    </h5>
                  </a>

                  <a
                    data-bs-toggle="modal"
                    data-bs-target="#modal-inscricao"
                    (click)="selecionarCurso(curso)"
                    class="rts-btn btn-primary with-arrow text-center mt-4"
                    [ngStyle]="{
                      display: 'block',
                      padding: '6px 20px',
                      'max-width': 'none',
                      width: '100%'
                    }"
                    >Inscreva-se <i class="fa-solid fa-arrow-right"></i
                  ></a>
                  <a
                    [routerLink]="['/cursos', curso.slug]"
                    class="d-block text-center text-primary mt-4"
                    >Saiba mais</a
                  >
                </div>
              </div>
            </div>
            <div class="row mt--30" *ngIf="cursosFiltrados.length > 0">
              <div class="col-lg-12">
                <div class="rts-pagination-area-2">
                  <ul>
                    <li
                      (click)="paginaAnterior()"
                      [class.disabled]="paginaAtual === 1"
                    >
                      <i class="fa-solid fa-chevron-left"></i>
                    </li>

                    <li
                      *ngFor="let pagina of getPaginasParaExibir()"
                      [class.active]="paginaAtual === pagina"
                      (click)="mudarPagina(pagina)"
                    >
                      {{ pagina }}
                    </li>

                    <li
                      (click)="proximaPagina()"
                      [class.disabled]="paginaAtual === totalPaginas"
                    >
                      <i class="fa-solid fa-chevron-right"></i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>

<!-- Modal de Pré-Inscrição -->
<div
  class="modal inscricao-popup-modal fade"
  id="modal-inscricao"
  tabindex="-1"
  aria-labelledby="modalInscricaoLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalInscricaoLabel">Inscreva-se</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="leadForm" (ngSubmit)="onSubmit()" class="login-form">
          <input type="text" placeholder="Nome" formControlName="name" />
          <input
            type="email"
            placeholder="E-mail"
            formControlName="email"
            (input)="onEmailInput($event)"
          />
          <input
            type="text"
            maxlength="20"
            placeholder="Celular"
            formControlName="mobile"
            placeholder="DDD + Celular"
            mask="(00) 00000-0000"
          />

          <button type="submit" class="rts-btn btn-primary">Continuar</button>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- Modal de Pré-Inscrição -->
